export default "__VITE_ASSET__Ch1w2gTz__"